import type { IContextMutationResult } from '@modules/core/services/query/types';
import {
  AFFILIATE_API_MUTATION_API_URL,
  AFFILIATE_API_MUTATION_KEY,
  AFFILIATE_API_PERMISSIONS,
  AFFILIATE_API_QUERY_KEY,
} from '@modules/affiliate-api/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

export default function useAffiliateApiResetTokenMutation(): IContextMutationResult<void, Error, void> {
  const { fetchPut } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, void>({
    mutationKey: [AFFILIATE_API_MUTATION_KEY],
    mutationFn: () => fetchPut<void>(
      AFFILIATE_API_MUTATION_API_URL,
      { },
      {
        permission: AFFILIATE_API_PERMISSIONS.SHOW,
      },
    ),
    async onSuccess({ queryClient }) {
      await queryClient.invalidateQueries({ queryKey: [AFFILIATE_API_QUERY_KEY] });

      displayPresetToast('success');
    },
  });
}
